module.exports = __webpack_public_path__ + "img/background.0683fe32.png";